import { styled } from "@mui/styles"
import PropTypes from "prop-types"
import React from "react"

import { Icon, List } from "../../../index.js"

const StepsListRoot = styled(List.Root)({
  backgroundColor: "#6b546a",
  borderRadius: 4,
  color: "#ffffff",
  fontSize: "1.4rem",
  maxWidth: 360,
  padding: "1rem",
  width: "100%",
})

const DoneStep = styled(List.Item)({
  "& > .MuiListItemIcon-root": { opacity: ".4" },
  "& > .MuiListItemText-root": { textDecoration: "line-through" },
})

const ListHeader = styled("div")({
  padding: "8px 16px",
  fontSize: "17px",
  lineHeight: "24px",
  fontWeight: "700",
})

const ListDescription = styled("div")({
  padding: "0 16px 8px",
  fontSize: "14px",
  lineHeight: "20px",
})

const CheckMark = <Icon color="#ffffff" name="check" />

export const CheckedList = ({ items, title = false, description = false }) => {
  return (
    <StepsListRoot>
      {(title || description) && (
        <>
          <ListHeader>{title}</ListHeader>
          <ListDescription>{description}</ListDescription>
        </>
      )}
      {items.map((item) => {
        return item.checked ? (
          <DoneStep
            adornment={CheckMark}
            content={item.content}
            ContentProps={{ disableTypography: true }}
          />
        ) : (
          <List.Item
            adornment={CheckMark}
            content={item.content}
            ContentProps={{ disableTypography: true }}
          />
        )
      })}
    </StepsListRoot>
  )
}

CheckedList.propTypes = {
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      checked: PropTypes.bool.isRequired,
      content: PropTypes.string.isRequired,
    }),
  ),
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}
